import { render, staticRenderFns } from "./TituloFormularioPeriodoLetivo.vue?vue&type=template&id=9662f54c&"
import script from "./TituloFormularioPeriodoLetivo.vue?vue&type=script&lang=js&"
export * from "./TituloFormularioPeriodoLetivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports